module.exports = __webpack_public_path__ + "static/media/Dash-Welcome.5df62cd9.svg";